// Client-side permission helpers + the permission catalog used by the role editor.

export const PERMISSIONS = [
  { key: 'view_dashboard', label: 'View Dashboard', group: 'General' },
  { key: 'view_leads', label: 'View Leads', group: 'Leads' },
  { key: 'manage_leads', label: 'Manage Leads', group: 'Leads' },
  { key: 'view_calls', label: 'View Calls & Follow-ups', group: 'Calls' },
  { key: 'manage_calls', label: 'Manage Calls & Follow-ups', group: 'Calls' },
  { key: 'view_calendar', label: 'View Calendar', group: 'Calendar' },
  { key: 'manage_calendar', label: 'Manage Calendar', group: 'Calendar' },
  { key: 'view_documents', label: 'View Documents', group: 'Documents' },
  { key: 'manage_documents', label: 'Manage Documents', group: 'Documents' },
  { key: 'view_clients', label: 'View Clients', group: 'Other' },
  { key: 'view_quotations', label: 'View Quotations', group: 'Other' },
  { key: 'view_packages', label: 'View Packages', group: 'Other' },
  { key: 'manage_settings', label: 'Manage Settings', group: 'Admin' },
  { key: 'manage_users', label: 'Manage Users & Roles', group: 'Admin' },
];

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); }
  catch { return null; }
};

export const getPermissions = () => {
  const u = getUser();
  return (u && Array.isArray(u.Permissions)) ? u.Permissions : [];
};

// If no permission list is present (legacy session), allow everything so users
// are never locked out. Otherwise enforce the list.
export const hasPerm = (key) => {
  const perms = getPermissions();
  if (!perms.length) return true;
  return perms.includes(key);
};

export const clearSession = () => {
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('user');
};
